import { render, staticRenderFns } from "./ProductsAtributes.vue?vue&type=template&id=2cc920e7&scoped=true"
import script from "./ProductsAtributes.vue?vue&type=script&lang=js"
export * from "./ProductsAtributes.vue?vue&type=script&lang=js"
import style0 from "./ProductsAtributes.vue?vue&type=style&index=0&id=2cc920e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc920e7",
  null
  
)

export default component.exports